import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  inject,
} from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

import {
  PictureData,
  ImageLoading,
  ImageRules,
} from '@digital-platform/rs-shared/domain';

@Component({
  selector: 'digital-platform-picture',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './picture.component.html',
})
export class PictureComponent implements OnInit, OnChanges {
  @Input() public customTemplate: TemplateRef<PictureData> | null = null;
  @Input() public pictureData: PictureData | null = null;
  @Input() public adaptiveImageRules: ImageRules[] | null = null;

  @Input() public webpSrc = '';
  @Input() public pngSrc = '';
  @Input() public altText: string | undefined | null;
  @Input() public loading: ImageLoading = ImageLoading.enum.eager;
  @Input() public addClass = '';
  @Input() public style = '';
  @Input() public width: number | undefined | null;
  @Input() public height: number | undefined | null;
  @Input() public imageId = '';

  @Output() public mouseEntered = new EventEmitter<void>();
  @Output() public mouseLeft = new EventEmitter<void>();

  public safeStyle: SafeStyle = '';
  public ImageLoading = ImageLoading;

  private domSanitizer = inject(DomSanitizer);

  public ngOnInit(): void {
    this.parsePictureDataIfSet();
    this.updateSources();
  }

  public ngOnChanges(): void {
    this.parsePictureDataIfSet();
    this.updateSources();
  }

  public mouseEnter(): void {
    this.mouseEntered.emit();
  }

  public mouseLeave(): void {
    this.mouseLeft.emit();
  }

  private parsePictureDataIfSet(): void {
    if (this.pictureData) {
      this.webpSrc = this.pictureData.webpSrc || this.webpSrc;
      this.pngSrc = this.pictureData.pngSrc || this.pngSrc;
      this.altText = this.pictureData.altText || this.altText;
      this.loading = this.pictureData.loading || this.loading;
      this.addClass = this.pictureData.addClass || this.addClass;
      this.width = this.pictureData.width || this.width;
      this.height = this.pictureData.height || this.height;
      this.style = this.pictureData.style || this.style;
      this.imageId = this.pictureData.imageId || this.imageId;
    }
  }

  private updateSources(): void {
    this.safeStyle = this.getSanitizedStyle(this.style);
    this.webpSrc = this.encodedImageSource(this.webpSrc);
    this.pngSrc = this.encodedImageSource(this.pngSrc);

    if (this.adaptiveImageRules) {
      const lastImage = this.adaptiveImageRules.length - 1;

      this.pngSrc = this.adaptiveImageRules[lastImage]?.imageMediaFile || '';
    }
  }

  private getSanitizedStyle(style: string): SafeStyle {
    return style ? this.domSanitizer.bypassSecurityTrustStyle(style) : '';
  }

  private encodedImageSource(source: string): string {
    return source ? encodeURI(source) : '';
  }
}
